import { PcbNodeTypes } from "@buildwithflux/models";
/**
 * This seems to exist to allow us to print the type name in the UI. The only
 * case where the UI name is different is "route" and "trace", which was renamed
 * after.
 *
 * QUESTION: can someone add more context?
 */
export function normalizePcbLayoutNodeType(type) {
    switch (type) {
        case PcbNodeTypes.routeSegment: {
            return "trace";
        }
        default: {
            return type;
        }
    }
}
//# sourceMappingURL=normalizePcbLayoutNodeType.js.map